import type { Catalog } from '..'

export const canvas: Catalog['canvas'] = {
  toolSelect: 'Selecionar',
  toolHand: 'Mão',
  toolFrame: 'Frame',
  toolRectangle: 'Retângulo',
  toolCircle: 'Círculo',
  toolPath: 'Caminho vetorial',
  toolText: 'Texto',
  toolComment: 'Comentário',

  untitled: 'Sem título',
  allCanvases: 'Todos os canvases',
  readOnlyBadgeTitle: 'Seu link de compartilhamento permite explorar, mas não alterar o design',
  canComment: 'Pode comentar',
  viewOnly: 'Somente visualização',
  canvasIdTitle: 'Id do canvas — os agentes usam isto com as ferramentas MCP',
  autoSaved: '— Salvo automaticamente',
  reconnecting: '— Reconectando…',
  justYou: 'Só você aqui',
  importTitle: 'Importar uma página web ao vivo como frame',
  import: 'Importar',
  exportTitle: 'Exportar frames como PDF',
  export: 'Exportar',
  share: 'Compartilhar',
  presentFromFrame: 'Apresentar a partir deste frame',
  presentPrototype: 'Apresentar o protótipo',
  addFrameToPresent: 'Adicione um frame para apresentar',
  presentPrototypeLabel: 'Apresentar protótipo',
  connectAi: 'Conectar IA',
  connectAiShort: 'IA',
  canvasActions: 'Ações do canvas',

  pasteImageFailed: 'Não foi possível colar a imagem — {error}',
  dropImageFailed: 'Não foi possível adicionar a imagem solta — {error}',
  uiHidden: 'Interface oculta · {key}. para mostrar',
  memorySuggestionReview: 'Sugestão de memória — revisar',
  hideForNow: 'Ocultar por enquanto',
  openMemory: 'Abrir Memória',
  savedToMemory: 'Salvo na Memória',
  linkCopied: 'Link do canvas copiado',
  itemsImported: { one: '{count} item importado', other: '{count} itens importados' },
  importedWithFailures: '{imported} · {failed} com falha',
  cardsQueued: {
    one: '{count} card na fila — o Doop está cuidando disso',
    other: '{count} cards na fila — o Doop está cuidando disso',
  },
  appUpdated: 'O doop foi atualizado',
  reload: 'Recarregar',

  notFoundTitle: 'Canvas não encontrado',
  notFoundBody:
    '“{id}” não corresponde a nenhum canvas que conhecemos. Ele pode ter sido excluído, ou o link pode estar errado.',
  backToCanvases: 'Voltar para seus canvases',

  resizeLayers: 'Redimensionar painel Camadas',
  resizeAgents: 'Redimensionar painel Agentes',
  canvasActionsDescription:
    'Camadas, importar, exportar, compartilhar, modo Protótipo ou as configurações da sua conta.',
  layers: 'Camadas',
  importWebsite: 'Importar site',
  shareCanvas: 'Compartilhar canvas',
  prototypeMode: 'Modo Protótipo',
  leavePrototypeMode: 'Sair do modo Protótipo',
  frameInspector: 'Inspetor do frame',
  canvasActivity: 'Atividade do canvas',

  canvasPanels: 'Painéis do canvas',
  inspectFrame: 'Inspecionar frame',
  help: 'Ajuda',
  docs: 'Documentação',
  contactSupport: 'Falar com o suporte',
  youAre: 'Você é “{name}” — clique para mudar seu nome',
  changeDisplayName: 'Mudar seu nome de exibição',
  agents: 'Agentes · ⌘K para pedir ao Doop Agent',
  agentsWorking: 'Agentes · {working} trabalhando · ⌘K para pedir ao Doop Agent',
  comments: 'Comentários',
  commentsOpen: 'Comentários · {open} abertos',
  activity: 'Atividade',
  memory: 'Memória',
  memorySuggestion: 'Memória · sugestão para revisar',

  openCanvases: 'Canvases abertos',
  closeTab: 'Fechar aba',
  newCanvas: 'Novo canvas',
  copyLink: 'Copiar link',
  openInBrowser: 'Abrir no navegador',
  closeOtherTabs: 'Fechar as outras abas',
  closeAllTabs: 'Fechar todas as abas',

  zoomIn: 'Aumentar zoom',
  zoomOut: 'Diminuir zoom',
  zoomLevel: 'Nível de zoom',
  zoomToFit: 'Ajustar à tela',
  zoomToSelection: 'Ajustar à seleção',
  zoomTo: 'Zoom em {percent}%',
  showRulers: 'Mostrar réguas',
  hideRulers: 'Ocultar réguas',

  gettingStarted: 'Primeiros passos',
  gettingStartedDescription: 'Dois passos para trazer seu próprio agente para o canvas.',
  stepConnect: 'Conecte seu próprio agente',
  stepConnectHint: 'Claude Code, Codex, Cursor ou qualquer cliente MCP pode desenhar neste canvas como você.',
  stepTask: 'Dê uma tarefa a ele',
  copiedLower: 'copiado',
  copyStarterPrompt: 'copiar um prompt inicial',
  stepTaskHint: 'Cole no chat do seu agente e veja o frame surgir em tempo real.',
  loopDone:
    'Esse é o ciclo. Mais um truque: passe o mouse sobre uma tarefa no painel e responda a ela — sua nota vira um pedido aberto que qualquer agente pega no meio do caminho.',
  gotIt: 'Entendi',
  dismiss: 'Dispensar',
  dismissChecklist: 'Dispensar checklist',

  agentOf: 'agente de {owner}',
  agent: 'agente',
  followAround: 'Seguir {name} pelo canvas',
  stopFollowing: 'Parar de seguir {name}',
  stopFollowingEsc: 'Parar de seguir (Esc)',
  goWhereWorking: '{label} — clique para ir aonde ele está trabalhando',
  online: '{online} online',
  following: 'Seguindo',

  displayNameTitle: 'Seu nome de exibição',
  displayNameLede: 'Aparece no seu cursor, no feed de atividade e em tudo o que você deixa para um agente.',
  name: 'Nome',
  saving: 'Salvando…',
  saveName: 'Salvar nome',

  reviewBeforeImport: 'Revise antes de importar',
  selectAll: 'Selecionar tudo',
  clear: 'Limpar',
  importing: 'Importando…',
  optional: 'Opcional',

  repoTitle: 'Importar o design system',
  repoFramework: 'Um app {framework}.',
  repoLede:
    'O Doop destila o design system do repositório em um guia de estilo fixado neste canvas — todo agente o segue a partir daí. Cada componente ou página que você escolher vira um card no quadro: o Doop o esboça a partir do código-fonte e o entrega como frame. Páginas inteiras são opcionais.',
  extractTitle: 'Extrair o design system para um guia de estilo',
  extractDescription:
    'Paleta, tipografia e espaçamento do tema do repositório — fixados no canvas e seguidos por todo agente.',
  screensToImport: 'Telas para importar',
  kindComponent: 'componente',
  kindStory: 'story',
  laneStatic: 'do repositório',
  lanePlaceholder: 'esboço do agente',
  hidePages: 'ocultar páginas',
  showPages: { one: 'mostrar {count} página (opcional)', other: 'mostrar {count} páginas (opcionais)' },
  repoTruncated: 'A listagem do repositório foi cortada — repositórios muito grandes mostram só uma parte.',
  repoImporting: 'O Doop está importando — o guia de estilo e os esboços aparecem no canvas…',
  repoImport: 'Importar {items}',
  repoPieceSystem: 'design system',
  repoPieceComponents: { one: '{count} componente', other: '{count} componentes' },
  repoPieceScreens: { one: '{count} tela', other: '{count} telas' },
  errScreensGone: 'Essas telas não estão mais no repositório — refaça a varredura',
  errAlreadyOnBoard: 'Tudo o que você escolheu já está no quadro',
  errRepoImportFailed: 'a importação do repositório falhou',

  websiteTitle: 'Importar um site',
  websiteLede:
    'Traga uma página, ou descubra um site inteiro e escolha as páginas que você quer antes de qualquer coisa ser adicionada.',
  websiteUrl: 'URL do site',
  wholeSiteTitle: 'Importar o site inteiro',
  wholeSiteDescription: 'Encontra páginas públicas no mesmo site e depois mostra a lista para revisão.',
  websiteNote: 'Os snapshots continuam editáveis e comentáveis. Scripts são removidos.',
  findingPages: 'Procurando páginas…',
  discoverPages: 'Descobrir páginas',
  importPage: 'Importar página',
  choosePages: 'Escolha as páginas',
  pagesFound: {
    one: '{count} página encontrada. Tudo vem selecionado; desmarque o que você não precisa.',
    other: '{count} páginas encontradas. Tudo vem selecionado; desmarque o que você não precisa.',
  },
  pagesToImport: 'Páginas para importar',
  pagesTruncated: 'Mostrando as primeiras 100 páginas encontradas. Restrinja a URL inicial se precisar.',
  capturingPages: 'Capturando {count} páginas — sites maiores podem levar alguns minutos.',
  importingCount: 'Importando {count}…',
  importPages: { one: 'Importar {count} página', other: 'Importar {count} páginas' },
  errImportFailed: 'a importação falhou',
  errDiscoveryFailed: 'a descoberta de páginas falhou',
  errNoPages: 'Nenhuma página pôde ser importada',
  errNoPagesReason: 'Nenhuma página pôde ser importada — {reason}',
  errWebsiteImportFailed: 'a importação do site falhou',

  syncTitle: 'Sincronizar um app ao vivo',
  syncForbidden: 'Chaves de sincronização são para membros do canvas — peça acesso permanente ao dono.',
  syncLede:
    'Para apps que um crawler não alcança: atrás de um login, de uma VPN ou em localhost. Cole uma tag de script e cada tela que as pessoas visitam chega aqui como frame, importada uma única vez.',
  screens: { one: '{count} tela', other: '{count} telas' },
  synced: 'sincronizado',
  neverSynced: 'nunca sincronizado',
  revokeKey: 'Revogar esta chave',
  copiedBang: 'Copiado!',
  appName: 'Nome do app',
  appNamePlaceholder: 'Painel administrativo',
  createKey: 'Criar chave',
  syncStep1Title: 'Gere uma chave para este canvas',
  syncStep1Detail: 'A chave só escreve aqui. Revogue-a nesta tela quando quiser.',
  syncStep2Title: 'Cole a tag de script',
  syncStep2Detail: 'Uma tag de script no layout do seu app. Nada mais para instalar.',
  syncStep3Title: 'Navegue pelo app',
  syncStep3Detail: 'Cada nova tela que alguém visita chega como frame. Exclua um frame para reimportá-lo do zero.',
  syncNote:
    'O conteúdo visível da página é enviado ao Doop como HTML estático. Valores de campos são descartados; marque qualquer coisa sensível com data-doop-mask.',

  githubTitle: 'Conectar um repositório do GitHub',
  githubForbidden: 'Conexões de repositório são para membros do canvas — peça acesso permanente ao dono.',
  githubLede:
    'O Doop lê as convenções de rotas do repositório e lista as telas para revisão. Nada é adicionado até você escolher.',
  nothingImported: 'nada importado ainda',
  analyzing: 'Analisando…',
  analyze: 'Analisar',
  disconnectRepo: 'Desconectar este repositório',
  pickRepo: 'Escolha um repositório para conectar a este canvas',
  private: 'privado',
  connecting: 'Conectando…',
  connect: 'Conectar',
  allConnected: 'Todos os repositórios instalados estão conectados.',
  openingGithub: 'Abrindo o GitHub…',
  connectGithub: 'Conectar GitHub',
  pasteToken: 'colar um token em vez disso',
  repoPlaceholder: 'dono/repositório',
  tokenPlaceholder: 'Token fine-grained (github_pat_…)',
  githubNoteApp: 'O acesso fica restrito aos repositórios que você escolher e pode ser revogado no GitHub.',
  githubNoteToken: 'Um token fine-grained, somente leitura — ele nunca sai do servidor.',
  errListRepos: 'não foi possível listar os repositórios instalados',
  errStartInstall: 'não foi possível iniciar a instalação do GitHub',
  errConnectRepo: 'não foi possível conectar o repositório',
  errAnalysis: 'a análise do repositório falhou',
}
